// @flow

import { useState, useEffect, useContext, useCallback } from 'react';
import { ControllerContext } from './controller';
import { type IncomingPayment, fetchIncomingPayment } from '@tectonics/prs/incoming-payment';

export function useFetchIncomingPayment(setIncomingPayment: (IncomingPayment) => void): [bool, ?Error, () => void] {
  const [fetching, setFetching] = useState<boolean>(true);
  const [fetchingError, setFetchingError] = useState<?Error>(null);
  const { hash, localTenancy } = useContext(ControllerContext);
  const [reloadCounter, setReloadCounter] = useState<number>(0);
  const requestReload = useCallback(() => {
    setReloadCounter(reloadCounter => reloadCounter + 1);
  }, []);

  useEffect(() => {
    setFetching(true);
    setFetchingError(null);

    (async () => {
      try {
        const incomingPayment = await fetchIncomingPayment(hash, localTenancy);

        setIncomingPayment(incomingPayment);
        setFetching(false);
      } catch(e) {
        setFetchingError(e);
        setFetching(false);
      }
    })();
  }, [hash, setIncomingPayment, setFetching, localTenancy, reloadCounter]);

  return [fetching, fetchingError, requestReload];
}
